import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './LogoutPage.html';
import GlobalLogoutService from '../../Services/GlobalLogoutService';
import {
  ensureSsoRuntimeConfigLoaded,
  getSsoLogoutUrl,
  redirectToSsoLogin,
} from '../../Services/ssoNavigation';

@WithRender
@Component({
  diProvide: [GlobalLogoutService],
})
export default class LogoutPage extends Vue {
  @Inject(GlobalLogoutService) public globalLogoutService!: GlobalLogoutService;

  public async mounted() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('embedded') === '1') {
        await this.globalLogoutService.clearLocalSession();
        return;
      }

      const returnUrl = urlParams.get('returnUrl');
      if (returnUrl) {
        await this.globalLogoutService.clearLocalSession();
        window.location.href = returnUrl;
        return;
      }

      await ensureSsoRuntimeConfigLoaded();
      window.location.href = getSsoLogoutUrl();
    } catch (error) {
      console.error('Error during logout', error);
      await redirectToSsoLogin();
    }
  }
}
